<template>
    <div class="rds" v-loading="loading" element-loading-text="拼命加载中">
        <el-scrollbar height="calc(100vh - 120px)">
            <div class="tableSelect" ref="tableSelect" style="margin-bottom:0;">
                <el-form :inline="true" :model="formInline" label-position="left">
                    <el-form-item label="日期：">
                        <el-date-picker 
                            style="width:120px;"
                            @change="search"
                            format="YYYY-MM"
                            value-format="YYYYMM"
                            v-model="formInline.month"
                            type="month"
                            placeholder="选择月">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="地区：">
                        <el-select v-model="formInline.region" clearable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in regionList"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Payers：" v-if="curRole!='customer'">
                        <el-select v-model="formInline.payer_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in payersList"
                                :key="index"
                                :label="item.name+'('+item.payer_id+')'"
                                :value="item.payer_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售：" v-if="curRole=='admin'">
                        <el-select clearable filterable v-model.trim="formInline.sales" placeholder="请选择" @change="search" style="width:120px">
                            <el-option
                                v-for="item in salesList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="伙伴：" v-if="curRole=='admin'||curRole=='sales'">
                        <el-select clearable filterable v-model.trim="formInline.agent_id" placeholder="请选择" @change="search" style="width:120px">
                            <el-option
                                v-for="item in agentsList"
                                :key="item.agent_id"
                                :label="item.company"
                                :value="item.agent_id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户：" v-if="curRole!='customer'">
                        <el-select v-model="formInline.company_id" clearable filterable style="width:120px" @change="search" placeholder="请选择">
                            <el-option
                                v-for="(item,index) in customersList"
                                :key="index"
                                :label="item.company"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="rdsdata">
                    <el-row class="boxRow">
                        <el-col :span="7" v-if="rdsData && rdsData.rds && rdsData.rdslist && rdsData.rdslist.length >= 2">
                            <el-row class="ec2Cost">
                                <el-card :class="curRole!='customer'?'h160':'h314'">
                                    <div class="title">RDS费用</div>
                                    <div class="cost">
                                        <div class="left">
                                            <p>{{ rdsData.rdslist[rdsData.rdslist.length - 2].month }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rdslist[rdsData.rdslist.length - 2].total).toFixed(2) }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rdslist[rdsData.rdslist.length - 2].usage).toFixed(2) }}</p>
                                        </div>
                                        <div class="left">
                                            <p>{{ rdsData.rds.month }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rds.total).toFixed(2) }}</p>
                                            <p>{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rds.usage).toFixed(2) }}</p>
                                        </div>
                                    </div>
                                    <div class="percent">
                                        <div style="font-size:30px" v-if="Number(rdsData.rdslist[rdsData.rdslist.length - 2].total) != Number(rdsData.rds.total)">
                                             {{ percentage(rdsData.rdslist[rdsData.rdslist.length - 2].total,rdsData.rds.total) }}
                                            <img :src="Number(rdsData.rdslist[rdsData.rdslist.length - 2].total)>Number(rdsData.rds.total)?require('../../assets/img/down.png'):require('../../assets/img/up.png')" alt="">
                                        </div>
                                        <div style="font-size:30px;" v-else>NA</div>
                                    </div>
                                </el-card>
                            </el-row>
                            <el-row v-if="curRole!='customer'">
                                <el-col :span="8">
                                    <el-card class="h80">
                                        <div class="title">积分</div>
                                        <div class="num">{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rds.credit).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="8">
                                    <el-card class="h80">
                                        <div class="title">RI抵扣</div>
                                        <div class="num">{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rds.rifee).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="8">
                                    <el-card class="h80">
                                        <div class="title">税</div>
                                        <div class="num">{{formInline.region=='cn'?'¥':'$'}}{{ Number(rdsData.rds.tax).toFixed(2) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="5" v-if="rdsData">
                            <el-row>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">实例数量</div>
                                        <div class="num1">{{ Number(rdsData.rds.instanceCount) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">区域数量</div>
                                        <div class="num1">{{ Number(rdsData.rds.regionCount) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">硬盘数量</div>
                                        <div class="num1">{{ Number(rdsData.rds.ebsCount) }}</div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12">
                                    <el-card class="h120">
                                        <div class="title">快照数量</div>
                                        <div class="num1">{{ Number(rdsData.rds.snapshotCount) }}</div>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <el-card class="">
                                <div class="title" style="font-size:18px;">RDS-费用详情</div>
                                <div id="chart1" class="chart"></div>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">RDS-Instances</div>
                            <el-table stripe :data="instanceList" ref="tableref" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="实例ID" prop="resId" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="型号" prop="type" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="系统详情" prop="" :show-overflow-tooltip="true">
                                    <template #default="scope">
                                        {{ scope.row.os +'/'+ scope.row.cpu +'c/'+ scope.row.mem }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="CPU型号" prop="cpufeatures" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="使用时长" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="实例成本" prop="onDemandCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.onDemandCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="付费模型" prop="pricingTerm" align="right"></el-table-column>
                                <el-table-column label="节省" prop="" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ (Number(scope.row.onDemandCost) - Number(scope.row.unblendedCost)).toFixed(2) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                        </el-card>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">RDS-Volumn</div>
                            <el-table stripe :data="storageList" ref="tableref1" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="ID" prop="resId" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="型号" prop="type"></el-table-column>
                                <el-table-column label="容量" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="费用" prop="unblendedCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.unblendedCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
                        </el-card>
                    </el-row>
                    <el-row class="tableRow">
                        <el-card>
                            <div class="title">RDS-快照</div>
                            <el-table stripe :data="snapshotList" ref="tableref2" height="300" style="width: 100%">
                                <el-table-column label="账户" prop="linkId"></el-table-column>
                                <el-table-column label="区域" prop="region"></el-table-column>
                                <el-table-column label="ID" prop="resId" :show-overflow-tooltip="true"></el-table-column>
                                <el-table-column label="型号" prop="type"></el-table-column>
                                <el-table-column label="容量" prop="usage" align="right">
                                    <template #default="scope">{{ Number(scope.row.usage).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="快照费" prop="unblendedCost" align="right">
                                    <template #default="scope">{{ Number(scope.row.unblendedCost).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="积分" prop="credit" align="right" v-if="curRole!='customer'">
                                    <template #default="scope">
                                        {{ scope.row.credit?Number(scope.row.credit).toFixed(2):'0' }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="其他" prop="tax" align="right">
                                    <template #default="scope">{{ Number(scope.row.tax).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column label="合计" prop="total" align="right">
                                    <template #default="scope">{{ Number(scope.row.total).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                            <Pagination v-bind:child-msg="pageparm2" @callFather="callFather2"></Pagination>
                        </el-card>
                    </el-row>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script>
    import {getRDSData,getRDSDetails,getSalesList,getAgentList,getCustomerList,getPayerList} from '@/api/api'
    import * as echarts from 'echarts';
    import Pagination from "@/components/Pagination";
    export default{
        name:'rdsSummary',
        components:{
            Pagination
        },
        data(){
            return{
                curRole:localStorage.getItem('curRole'),
                agentsList:[],
                payersList:[],
                customersList:[],
                salesList:[],
                formInline:{
                    month:0,
                    region:'cn',
                    sales:'',
                    agent_id:'',
                    payer_id:'',
                    company_id:''
                },
                regionList:[
                    {label:'全部',value:''},
                    {label:'中国',value:'cn'},
                    {label:'Global',value:'global'} 
                ],
                loading:false,
                rdsData:null,
                instanceParams:{
                    type:'instance',
                    page:1,
                    limit:20
                },
                pageparm: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                instanceList:[],
                storageParams:{
                    type:'storage',
                    page:1,
                    limit:20
                },
                pageparm1: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                storageList:[],
                snapshotParams:{
                    type:'snapshot',
                    page:1,
                    limit:20
                },
                pageparm2: {
                    page: 1,
                    limit: 20,
                    total: 0
                },
                snapshotList:[]
            }
        },
        created(){
            let date = new Date();
            //获取当前年份的后一年
            let endY =date.getFullYear();
            //获取上一个月
            let endM = (date.getMonth() < 10 ? '0' + (date.getMonth() ) : date.getMonth());
            this.formInline.month = endY+endM;
            if(this.curRole=='agent'||this.curRole=='customer'){
                this.formInline.region='global'
            }
            this.getPermissionList();
        },
        methods:{
            async getPermissionList(){
                this.loading = true;
                if(this.curRole!='customer'){
                    await this.getPayersList();
                    await this.getAgentsList();
                }
                if(this.curRole=='admin'||this.curRole=='sales'){
                    await this.getSaleList();
                }
                await this.getCustomersList();
                await this.search()
                this.loading = false;
            },
            //获取列表
            async search() {
                this.loading = true;
                try {
                await getRDSData(this.formInline).then(res => {
                    if(res.code ==2000) {
                        this.rdsData = res.data;
                        this.rdsData.rds.usage = Number(this.rdsData.rds.usage).toFixed(2);
                        this.rdsData.rds.tax = Number(this.rdsData.rds.tax).toFixed(2);
                        this.rdsData.rds.credit = Number(this.rdsData.rds.credit).toFixed(2);
                        this.rdsData.rds.rifee = Number(this.rdsData.rds.rifee).toFixed(2);
                        this.rdsData.rds.sp = Number(this.rdsData.rds.sp).toFixed(2);
                        this.rdsData.rds.others = Number(this.rdsData.rds.others).toFixed(2);
                        this.rdsData.rds.total = 
                        (Number(this.rdsData.rds.usage)+
                        Number(this.rdsData.rds.tax)+
                        Number(this.rdsData.rds.credit)+
                        Number(this.rdsData.rds.sp)+
                        Number(this.rdsData.rds.rifee)).toFixed(2);
                        var xData=[],yData={
                            usage:[],
                            rifee:[],
                            sp:[],
                            credit:[],
                            tax:[],
                            others:[]
                        };
                        this.rdsData.rdslist.forEach(el=>{
                            el.usage = Number(el.usage).toFixed(2);
                            el.tax = Number(el.tax).toFixed(2);
                            el.credit = Number(el.credit).toFixed(2);
                            el.rifee = Number(el.rifee).toFixed(2);
                            el.sp = Number(el.sp).toFixed(2);
                            el.others = Number(el.others).toFixed(2);
                            el.total = (Number(el.usage)+
                                        Number(el.tax)+
                                        Number(el.credit)+
                                        Number(el.sp)+
                                        Number(el.rifee)).toFixed(2);
                            xData.push(el.month);
                            yData.usage.push(el.usage);
                            yData.rifee.push(el.rifee);
                            yData.sp.push(el.sp);
                            yData.credit.push(el.credit);
                            yData.tax.push(el.tax);
                            yData.others.push(el.others);
                        })
                        this.$nextTick(()=>{
                            this.loadLineChart(document.getElementById('chart1'),xData,yData)
                        })
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
                await this.getDetails(1)
                await this.getDetails(2)
                await this.getDetails(3)
                } finally {
                    this.loading = false;
                }
            },
            async getDetails(type){
                var data={};
                if(type==1){
                    data = Object.assign({},this.formInline,this.instanceParams);
                }else if(type == 2){
                    data = Object.assign({},this.formInline,this.storageParams);
                }else{
                    data = Object.assign({},this.formInline,this.snapshotParams);
                }
                await getRDSDetails(data).then(res=>{
                    if(res.code==2000){
                        if(type==1){
                            this.instanceList = res.data;
                            this.pageparm.page = res.page;
                            this.pageparm.limit = res.limit;
                            this.pageparm.total = res.total;
                        }else if(type==2){
                            this.storageList = res.data;
                            this.pageparm1.page = res.page;
                            this.pageparm1.limit = res.limit;
                            this.pageparm1.total = res.total;
                        }else{
                            this.snapshotList = res.data;
                            this.pageparm2.page = res.page;
                            this.pageparm2.limit = res.limit;
                            this.pageparm2.total = res.total;
                        }
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            callFather(parm) {
                this.instanceParams.page = parm.page
                this.instanceParams.limit = parm.limit
                this.getDetails(1)
            },
            callFather1(parm) {
                this.storageParams.page = parm.page
                this.storageParams.limit = parm.limit
                this.getDetails(2)
            },
            callFather2(parm) {
                this.snapshotParams.page = parm.page
                this.snapshotParams.limit = parm.limit
                this.getDetails(3)
            },
            // 获取伙伴列表
            async getAgentsList(){
                await getAgentList({company:'',payers:'',sales:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.agentsList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 获取销售列表
            async getSaleList(){
                await getSalesList({name:'',phone:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.salesList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取客户列表
            async getCustomersList(){
                await getCustomerList({company:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.customersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            },
            // 获取payer列表
            async getPayersList(){
                await getPayerList({name:'',payer_id:'',region:'',page:1,limit:999999}).then(res=>{
                    if(res.code==2000){
                        this.payersList=res.data.data;
                    }else{
                        this.$message.error(JSON.stringify(res.msg));
                    }
                })
            }, 
            // 计算两个值的percent,num1为上月费用，num2为当月费用
            percentage(num1,num2){
                var numA = Number(num1).toFixed(2);
                var numB = Number(num2).toFixed(2);
                let upOrDown = '', percent = '';
                if (Number(numA) < Number(numB)) {
                    upOrDown = '+';
                    percent = Math.abs((((Number(numB) - Number(numA)) / Number(numA))*100).toFixed(2)) + '%';
                } else if (Number(numA) > Number(numB)) {
                    upOrDown = '-';
                    percent = Math.abs((((Number(numA) - Number(numB)) / Number(numA))*100).toFixed(2)) + '%';
                }
                return `${upOrDown}${percent}`
            },

            loadLineChart(dom,xData,yData){
                var myChart = echarts.getInstanceByDom(dom) || echarts.init(dom);
                var option,_this = this;
                option = {
                    tooltip: {
                        trigger: 'axis',
                        valueFormatter:function(value){
                            if(_this.formInline.region=='cn'){
                                return '￥'+value
                            }else{
                                return '$'+value
                            }
                        }
                    },
                    legend: {
                        data: ['Usage', 'RIFee', 'SP抵扣', '积分', 'Tax','Other']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'Usage',
                            type: 'line',
                            stack: 'Total',
                            data: yData.usage
                        },
                        {
                            name: 'RIFee',
                            type: 'line',
                            stack: 'Total',
                            data: yData.rifee
                        },
                        {
                            name: 'SP抵扣',
                            type: 'line',
                            stack: 'Total',
                            data: yData.sp
                        },
                        {
                            name: '积分',
                            type: 'line',
                            stack: 'Total',
                            data: yData.credit
                        },
                        {
                            name: 'Tax',
                            type: 'line',
                            stack: 'Total',
                            data: yData.tax
                        },
                        {
                            name: 'Other',
                            type: 'line',
                            stack: 'Total',
                            data: yData.others
                        }
                    ]
                };
                option && myChart.setOption(option);
            },
        },
    }
</script>
<style lang="scss">
    .rds{
        height:calc(100vh - 120px);
        overflow-y:auto;
        background:#fff;
        box-shadow: 0 0 5px #ccc;
        .rdsdata{
           margin-top:10px; 
        }
        .el-loading-spinner{
            top:300px;
        }
        .el-card.h240{
            height:240px;
        }
        .el-card.h160{
            height:212px;
        }
        .el-card.h314{
            height:314px;
            .cost{
                margin-top:70px;
            }
        }
        .el-card.h120{
            height:156px;
            .el-card__body .title{
                font-size:18px;
            }
        }
        .el-card.h80{
            height:100px;
            .el-card__body .title{
                font-size:16px;
            }
        }
        .el-card__body{
            position: relative;
            .title{
                font-size:24px;
                border-left:4px solid #409eff;
                margin-bottom: 20px;
                padding-left:8px;
            }
            .cost{
                display: flex;
                justify-content: space-between;
                .left{
                    p{
                        font-size:18px;
                        margin-top:20px;
                        font-weight:bold;
                    }
                    p:first-child{
                        font-size:20px;
                        margin-top:12px;
                        font-weight:normal;
                    }
                    p:last-child{
                        color:#ccc;
                        font-weight:normal;
                        text-decoration:line-through;
                    }
                }
            }
            .percent{
                position: absolute;
                left:50%;
                bottom:50px;
                transform: translate(-50%,0);
                font-size:30px;
                img{
                    width: 14px;
                }
            }
            .num{
                font-size:14px;
                text-align: center;
                line-height:32px;
            }
            .num1{
                font-size:24px;
                text-align: center;
                line-height:72px;
            }
        }
        .boxRow{
            display: flex;
            .el-col{
                .ec2Cost{
                    display: block;
                }
            }
            .cont{
                width:calc(100% - 40px);
                background: #fff;
                border-radius: 4px;
                box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
                padding: 20px;
                .title{
                    font-size:14px;
                    border-left:4px solid #409eff;
                    margin-bottom: 20px;
                    padding-left:8px;
                }
            }
            .chart{
                width:100%;
                height:236px;    
            }
            .chart2{
                height:350px;
            }
            .chart3{
                height:500px;
            }
        }
        .tableRow{
            display: block;
            margin-top:10px;
            .lyPagination-page{
                box-shadow: none;
                border:none;
            }
            .el-card__body{
                padding-bottom:0;
            }
        }
    }
</style>